import type { FC } from 'react';
import { CSSTransition as ReactCssTransition } from 'react-transition-group';
import { CssTransitionWrapper } from './CssTransition.styled';
import { CssTransitionProps } from './types';

export const CssTransition: FC<CssTransitionProps> = ({ show, direction, children, timeout = 300 }) => {
    return (
        <ReactCssTransition in={show} classNames={direction} timeout={timeout} unmountOnExit>
            <CssTransitionWrapper timeout={timeout}>{children}</CssTransitionWrapper>
        </ReactCssTransition>
    );
};

CssTransition.displayName = 'CssTransition';
